<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-normal" (click)="goToBack()">
        <i class="material-icons">arrow_back</i>
      </div>
    </div>
    <div class="ir-line--right" *ngIf="inspection">
      <div class="ir-btn th-btn-normal black" (click)="gotoValidationSummaryPage()">
        <i class="material-icons-outlined">assignment_turned_in</i>
        <span class="th-btn-badge success" *ngIf="!errorMessage"><i class="material-icons">done</i></span>
        <span class="th-btn-badge error" *ngIf="errorMessage">{{
          validatedPlugins.length > 9 ? '9+' : validatedPlugins.length
        }}</span>
      </div>
      <div class="th-header-divider"></div>
      <div class="ir-btn th-btn-normal" *ngIf="isConnection" (click)="openMenu('inspections')">
        <i class="material-icons">assignment_add</i>
      </div>
      <div *ngIf="isConnection" class="th-header-divider"></div>
      <div class="ir-btn th-btn-icon" *ngIf="!isConnection">
        <i class="material-icons">portable_wifi_off</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="gotoInformationPage()">
        <i class="material-icons">contacts</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="refreshPage()">
        <i class="material-icons">refresh</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="exportInspections()" *ngIf="isConnection">
        <i class="material-icons">file_download</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="openMenu()" *ngIf="isConnection">
        <i class="material-icons">more_vert</i>
      </div>
    </div>
    <div class="ir-line-content" (click)="gotoEditPage()">
      <span
        >{{ inspection?.name }} <strong>({{ inspections?.length }})</strong></span
      >
    </div>
  </div>
</div>
<div class="ir-area ir-body th-body">
  <div class="th-loading" *ngIf="loading">
    <span>{{ 'common.loading' | translate }}...</span>
  </div>
  <children-inspection-list-table
    [inspections]="inspections"
    (toggleSelectInspection)="openInspection($event)"
    (toggleReport)="viewReport($event)"
  >
  </children-inspection-list-table>
</div>

<confirm
  #deleteConfirm
  (confirmOutput)="deleteInspection($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'inspections.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<order-summaries
  #orderPlugins
  [title]="'templates.order-plugins' | translate"
  (toggleSave)="savePluginsOrder($event)"
  (toggleCancel)="close()"
></order-summaries>
<inputlang
  #languagesModal
  (modalOutput)="selectLanguagesMenu($event)"
  [title]="'inspections.change-input-lang' | translate"
  [message]="'inspections.change-input-lang-warning' | translate"
  [danger]="true"
></inputlang>
<modal (modalOutput)="selectMenu($event)"></modal>
